<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2022-12-03 10:16:17
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-06 11:08:03
-->
<template>
  <div class="root">
    <h3>{{ detail.projectname }}</h3>
    <div class="father">
      <h4>项目详情</h4>
      <div class="child">
        <p>
          项目名称：
          <span>{{ detail.projectname }}</span>
        </p>
        <p></p>
        <p>
          鉴证编号：
          <span>{{ detail.jzsbh }}</span>
        </p>
        <p>
          项目编号：
          <span>{{ detail.numbering }}</span>
        </p>
        <p>
          标的名称：
          <span>{{ detail.projectname }}</span>
        </p>
        <p>
          成交总金额：
          <span>{{ detail.cjje }}元</span>
        </p>
        <p>
          成交方式：
          <span>{{ detail.jyfs }}</span>
        </p>
        <p>
          发布时间：
          <span>{{ detail.logintime }}</span>
        </p>

        <p>
          转出方：
          <span>{{ detail.outname }}</span>
        </p>
        <p>
          项目受让方：
          <span>{{ detail.needname }}</span>
        </p>
        <p>
          流转方式：
          <span>{{ detail.zcfs }}</span>
        </p>
        <p>
          转出期限：
          <span>{{ detail.zcqx }}</span>
        </p>

        <p>
          签约日期：
          <span>{{ detail.logintime }}</span>
        </p>
      </div>
    </div>

    <div class="father">
      <h4>签证事项联系</h4>
      <div class="child1">
        <p>
          联系人：
          <span>杨老师</span>
        </p>
        <p>
          联系方式：
          <span>0371-55088517</span>
        </p>
        <p>
          联系地址：
          <span></span>
        </p>
      </div>
    </div>

    <!-- <div class="demo-image__preview">
      <el-image
        v-for="(item, index) in srcList.length <= 6
          ? srcList
          : srcList.slice(0, 6)"
        :key="index"
          style="width: 200px; height: 200px; margin-right: 10px"
          :src="item"
        :preview-src-list="srcList"
        fit="cover"
      >
      </el-image>
    </div> -->

    <!-- <div class="father">
      <h4>报名须知</h4>
      <div class="child2">
        <p>一、报名人持下列材料到{{cityDetail.cityName}}农村产权交易服务中心报名：</p>
        <p>1、有效资格证件：</p>
        <p class="hui">（1） 意向受让方为自然人，需提供本人身份证复印件或常住人口户口簿复印件；</p>
        <p
          class="hui"
        >（2） 意向受让方为公司，需提供 法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、公司章程以及董事会或股东（大）会同意受让决议；</p>
        <p
          class="hui"
          >（3） 意向受让方为合作社，需提供法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、合作社成员同意受让决议。</p>
          <p>2、若为授权人提出申请，需提供授权委托书及身份证复印件。</p>
        <p>二、挂牌期满，若征集到符合条件的意向受让方，采取协议或者竞标方式确定受让方。</p>
        <p>三、法定节假日、公休日不受理报名。</p>
        <p class="cheng">{{cityDetail.cityName}}农村产权交易服务中心地址：{{cityDetail.cityName}}******</p>
      </div>
    </div> -->

    <!-- <div class="button">
        <a href="javascript:;">
          <img src="../assets/img/文件下载.png" alt />
        </a>
        <a href="javascript:;">
          <img src="../assets/img/立即报名.png" alt />
        </a>
      </div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      detail: {},
      srcList: [],
    }
  },
  created () {
    // console.log(this.$route.query.id);
    let id = this.$route.query.id
    let url = 'jianzhengshuxiangqing'
    console.log(this.ajax_id(url, id).data)
    this.detail = this.ajax_id(url, id).data
  },
  mounted () { },
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  display: block;
  margin: 0 auto;
  margin-bottom: 35px;
  padding: 0 260px;
  width: 1340px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.root > h3 {
  margin: 0 auto;
  padding: 50px 0 57px 0;
  width: 1200px;
  height: 26px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: #333333;
  letter-spacing: 5px;
  overflow: hidden;
}

.father {
  display: block;
  padding-bottom: 50px;
  width: 1340px;
  height: auto;
  overflow: hidden;
}

.father > h4 {
  display: block;
  padding-left: 10px;
  margin-bottom: 30px;
  border-left: 6px solid #2187ff;
  width: auto;
  height: 29px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 29px;
  color: #333333;
}

.child {
  width: 1340px;
  height: 346px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: space-between;
}

.child p {
  display: block;
  width: 670px;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #999999;
  overflow: hidden;
}

.child p span {
  color: #666666;
}

.child1 {
  width: 1340px;
  height: 130px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: space-between;
}

.child1 p {
  display: block;
  width: 100%;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #999999;
  overflow: hidden;
}

.child1 p span {
  color: #666666;
}

.child2 {
  width: 1340px;
  height: auto;
  display: block;
}

.child2 p {
  height: auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #666666;
}

.child2 .hui {
  color: #999999;
}

.child2 .cheng {
  color: #f96226;
}

.button {
  margin: 0 auto;
  margin-bottom: 90px;
  width: 460px;
  height: 50px;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.button a {
  display: block;
  width: 180px;
  height: 50px;
}

.button a img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
